import Badge from './Badge';
import Base from '../base';

/* istanbul ignore next */
Badge.install = function (Vue) {
  Vue.use(Base);
  Vue.component(Badge.name, Badge);
};

export default Badge;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/badge/index.js
// module id = 666
// module chunks = 0